/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/**
 * Provides a `cdsResizeChange` event when component dimensions are resized
 */
export function responsive(config = { skipFirst: false }) {
    return (target) => target.addInitializer((instance) => new ResponsiveController(instance, config));
}
export class ResponsiveController {
    constructor(host, config = { skipFirst: false }) {
        this.host = host;
        this.skipFirst = false;
        this.host.addController(this);
        this.skipFirst = !!config.skipFirst;
        this.resizeElement = config.element ? config.element : this.host;
    }
    async hostConnected() {
        await this.host.updateComplete;
        this.observer = new ResizeObserver(entries => {
            window.requestAnimationFrame(() => {
                if (this.skipFirst) {
                    this.skipFirst = false;
                }
                else {
                    this.host.dispatchEvent(new CustomEvent('cdsResizeChange', { detail: entries[0].contentRect }));
                    this.host.requestUpdate();
                }
            });
        });
        this.observer.observe(this.resizeElement);
    }
    hostDisconnected() {
        this.observer?.disconnect();
    }
}
